import { render, staticRenderFns } from "./LocalisationEditorHelper.vue?vue&type=template&id=54240efe&scoped=true&"
import script from "./LocalisationEditorHelper.vue?vue&type=script&lang=js&"
export * from "./LocalisationEditorHelper.vue?vue&type=script&lang=js&"
import style0 from "./LocalisationEditorHelper.vue?vue&type=style&index=0&id=54240efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54240efe",
  null
  
)

export default component.exports